export default __webpack_public_path__ + "static/greta-0c6f56e4e8d71edc8a864ef2a66ba752.png";